module.exports = __webpack_public_path__ + "static/media/duvel.34c37db2.jpg";